import { handoffTokenSchema, sessionSchema } from "../schemas/auth";
import { fetchApi } from "./internal";

export const session = {
	/** Mints a sign-in token for the caller so the venue portal can open already signed in. */
	handoff: () => fetchApi("/auth/tokens", handoffTokenSchema, { method: "POST" }),
	me: () => fetchApi("/session/me", sessionSchema),
};
